// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__TYqya","ReferralTxt":"ReferralCard_ReferralTxt__n3l-T"};